import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78dbd5e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-custom" }
const _hoisted_2 = ["type", "name", "id", "placeholder", "maxlength", "pattern", "disabled", "value", "required"]
const _hoisted_3 = {
  key: 0,
  class: "invalid-feedback"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass({ required: _ctx.required })
    }, _toDisplayString(_ctx.labelText), 3 /* TEXT, CLASS */),
    _createElementVNode("input", {
      type: _ctx.type,
      name: _ctx.name,
      id: _ctx.name,
      class: _normalizeClass(["form-control", {
        'is-invalid': _ctx.isInvalid,
        'is-valid': _ctx.isValid,
        disabled: _ctx.disabled || _ctx.isLoading,
      }]),
      placeholder: _ctx.isLoading ? 'Carregando...' : _ctx.placeholderText,
      maxlength: _ctx.maxLength,
      pattern: _ctx.pattern,
      disabled: _ctx.disabled || _ctx.isLoading,
      value: _ctx.displayValue,
      required: _ctx.required,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
      onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args))),
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
      onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args)))
    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_2),
    (_ctx.isInvalid && _ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}